import { useQuery } from '@tanstack/react-query';

import { notificationsApi } from '@/api/notifications';

/**
 * Сколько непрочитанных — для цифры у пункта меню куратора (11.09.2026).
 *
 * ⚠️ КЛЮЧ ПОД `['notifications']`. Отметка прочтения в ленте сбрасывает этот
 * префикс целиком — и цифра в меню уменьшается сразу, без ожидания опроса.
 * С ключом вне префикса она висела бы до следующего опроса.
 *
 * Опрос раз в минуту: куратор держит кабинет открытым часами, а новая сдача
 * должна появиться без перезагрузки.
 */
export function useUnreadNotifications(enabled: boolean): number | undefined {
  const unread = useQuery({
    queryKey: ['notifications', 'unread'],
    queryFn: notificationsApi.unreadCount,
    enabled,
    refetchInterval: enabled ? 60_000 : false,
  });
  return unread.data?.count;
}
